
















import { Component } from 'vue-property-decorator'
import { LoadList } from '@shared/mixins/loadList'
import { DropdownMenu, DropdownItem, Sticky } from 'vant'
import { find, map, split, toArray } from 'lodash'
import { getPosition, getRouterQuery } from '@utils/index'
import { queryStoreofActivityList, queryConsultantList } from '../category.service'

import CounselorList from '../components/counselorList/counselorList.vue'

@Component({
  components: {
    [Sticky.name]: Sticky,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    CounselorList,
  },
})
export default class ConsultantListComponent extends LoadList {
  selectStore = ''
  selectDistance = true
  selectSale = false
  storeList: any[] = []
  title = '全部门店'
  position: any = null

  init = []

  get selectedAll() {
    return this.selectStore === ''
  }
  get spuIds() {
    return getRouterQuery(this.$route.query.spuIds)
  }
  beforeCreate() {
    this.$setTitle('可服务育儿顾问')
  }
  async created() {
    this.position = await getPosition(false)
    const response: ResponseCode = await queryStoreofActivityList(this.spuIds)
    if (response && response.code == '1') {
      this.storeList = map(toArray(response.data), (item: any) => {
        return {
          value: item.storeCode,
          text: item.storeName,
        }
      })
      this.storeList.unshift({
        value: '',
        text: '全部门店',
      })
    }
  }

  onLoad() {
    this.getList()
  }

  changeAllStore() {
    this.selectStore = ''
    this.title = '全部门店'
    this.setInitResult()
    this.getList()
  }
  changeStore() {
    const currentStore: any = find(this.storeList, (o: any) => this.selectStore === o.value)
    this.selectStore = currentStore && currentStore.value
    this.title = currentStore && (currentStore.value ? currentStore.title : '全部门店')
    this.setInitResult()
    this.getList()
    window.scrollTo(0, 0)
  }
  changeDistance() {
    this.selectDistance = !this.selectDistance
    this.selectSale = false
    this.setInitResult()
    this.getList()
    window.scrollTo(0, 0)
  }
  changeSale() {
    this.selectSale = !this.selectSale
    this.selectDistance = false
    this.setInitResult()
    this.getList()
    window.scrollTo(0, 0)
  }
  async getList() {
    this.result.loading = true
    const pageIndex = ++this.result.pageIndex
    const pageSize = this.result.pageSize
    const response: ResponseCode = await queryConsultantList({
      pageIndex,
      pageSize,
      spuId: split(this.spuIds, ','),
      storeCode: this.selectStore || undefined,
      longitude: this.position && this.position.lng,
      latitude: this.position && this.position.lat,
      sort: this.selectSale ? 1 : this.selectDistance ? 2 : undefined,
    })
    if (pageIndex === 1) {
      this.result.list = []
    }
    this.result.loading = false
    if (response && response.code == '1') {
      const list: any[] = toArray(response.data)
      this.result.list = this.result.list.concat(list)
      if (list.length < this.result.pageSize) {
        this.result.finished = true
      }
    } else {
      --this.result.pageIndex
      this.result.error = true
    }
  }
}
